import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutStore } from '@pepconnect/features/checkout/checkout.store';
import { OrderItemType } from '@pepconnect/features/checkout/models/checkout-order-item.model';

@Component({
  selector: 'app-checkout-confirmation-total',
  templateUrl: './checkout-confirmation-total.component.html',
  styleUrls: ['./checkout-confirmation-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutConfirmationTotalComponent {
  readonly transaction$ = this.checkoutStore.transaction$;
  orderItemType = OrderItemType;

  constructor(private checkoutStore: CheckoutStore) { }
}
